import { useState, useEffect } from 'react'

export const useMedia = (q: string) => {
  const mq = window.matchMedia(q)
  const getValue = () => mq.matches
  const [value, setValue] = useState(getValue)

  useEffect(
    () => {
      const handler = () => setValue(getValue)
      mq.addEventListener('change', handler)
      return () => mq.removeEventListener('change', handler)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )
  return value
}
